import { AlignLeft, Circle, Flag, User, Lightbulb, LayoutGrid, Tag, Clock, CalendarPlus, Link2, Eye, CheckCircle2, RotateCcw, ListChecks } from "lucide-react";

// Canonical Master Topic lifecycle presentation (R2-B). Amber = attention, not
// punitive; approved uses the positive brand accent/success token.
export const STATUS_META = {
  idea: { label: "Idea", cls: "bg-accent-subtle text-accent", icon: Lightbulb },
  under_review: { label: "Under Review", cls: "bg-warning/10 text-warning", icon: Eye },
  approved: { label: "Approved", cls: "bg-success/10 text-success", icon: CheckCircle2 },
  returned_for_changes: { label: "Returned for Changes", cls: "bg-warning/10 text-warning", icon: RotateCcw },
};
export const STATUS_FILTER_OPTIONS = [
  ["idea", "Idea"], ["under_review", "Under Review"], ["approved", "Approved"], ["returned_for_changes", "Returned for Changes"],
];

// Topics & Ideas — module definition for the ContentOS Collection Standard.
// Defines the sortable options, optional display properties (title is implicit
// and can never be hidden) and default browsing behaviour.
export const TOPIC_SORTS = [
  { value: "updated", label: "Recently Updated" },
  { value: "created", label: "Recently Created" },
  { value: "created_asc", label: "Oldest Created" },
  { value: "title", label: "Title A–Z" },
  { value: "title_desc", label: "Title Z–A" },
  { value: "priority_high", label: "Priority High → Low" },
  { value: "priority_low", label: "Priority Low → High" },
  { value: "inspirations_desc", label: "Most Inspirations" },
  { value: "inspirations_asc", label: "Least Inspirations" },
];

export const ASPECT_LABEL = {
  HOOK: "Hook", STORYTELLING: "Storytelling", STRUCTURE: "Structure", VISUAL: "Visual",
  EDITING: "Editing", CAPTION: "Caption", CTA: "CTA", TOPIC_ANGLE: "Topic Angle", OTHER: "Other",
};
export const ASPECT_OPTIONS = Object.entries(ASPECT_LABEL).map(([value, label]) => ({ value, label }));
export const PLATFORM_OPTIONS = ["Instagram", "YouTube", "Web", "Other"];

export const DATE_PRESETS = [
  ["any", "Any time"], ["today", "Today"], ["7d", "Last 7 days"],
  ["30d", "Last 30 days"], ["month", "This month"], ["custom", "Custom range"],
];
export const DATE_PRESET_LABEL = Object.fromEntries(DATE_PRESETS);

const isoDay = (d) => {
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

// Resolve a date preset (or custom from/to) into {from, to} yyyy-MM-dd strings.
export function presetRange(preset, from = "", to = "") {
  const now = new Date();
  if (preset === "today") { const d = isoDay(now); return { from: d, to: d }; }
  if (preset === "7d") { const s = new Date(now); s.setDate(now.getDate() - 6); return { from: isoDay(s), to: isoDay(now) }; }
  if (preset === "30d") { const s = new Date(now); s.setDate(now.getDate() - 29); return { from: isoDay(s), to: isoDay(now) }; }
  if (preset === "month") { const s = new Date(now.getFullYear(), now.getMonth(), 1); return { from: isoDay(s), to: isoDay(now) }; }
  if (preset === "custom") return { from: from || "", to: to || "" };
  return { from: "", to: "" };
}

export const topicCollectionDef = {
  key: "topics",
  defaultDensity: "comfortable",
  defaultSort: "updated",
  properties: [
    { key: "summary", label: "Summary", icon: AlignLeft },
    { key: "status", label: "Status", icon: Circle },
    { key: "readiness", label: "Readiness", icon: ListChecks },
    { key: "priority", label: "Priority", icon: Flag },
    { key: "owner", label: "Owner", icon: User },
    { key: "inspiration_count", label: "Inspiration count", icon: Lightbulb },
    { key: "platforms", label: "Platforms", icon: LayoutGrid },
    { key: "aspects", label: "Inspiration aspects", icon: Tag },
    { key: "updated", label: "Updated date", icon: Clock },
    { key: "created", label: "Created date", icon: CalendarPlus },
    { key: "links", label: "Inspiration links (Detailed)", icon: Link2 },
  ],
};
